import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Typography,
} from "@mui/material";
import React from "react";
import plus from "../../assets/images/website/plus.png";

function FaqSection() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <React.Fragment>
      <Container maxWidth="xl">
        <Box sx={{ marginTop: {xs: '58px' , lg: "84px"} }}>
          <Typography
            sx={{
              color: "#212529",
              fontSize: 36,
              fontWeight: 700,
              fontFamily: '"Inter", sans-serif',
              lineHeight: "44px",
              textAlign: "center",
            }}
          >
            FAQ
          </Typography>
          <Typography
            sx={{
              color: "#212529",
              fontSize: {xs: 18 , lg :22},
              fontWeight: 400,
              fontFamily: '"Inter", sans-serif',
              lineHeight: "30px",
              marginTop: "24px",
              textAlign: "center",
            }}
          >
            You can find answers to frequently asked questions here.
          </Typography>
        </Box>
        <Box sx={{ margin: {xs: '39px 0px 89px' , lg: "50px 0px 165px"} }}>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            sx={{
              border: expanded === "panel1" && "1px solid #E63B1F",
              borderRadius: "6px",
              marginBottom: "12px",
            }}
          >
            <AccordionSummary
              expandIcon={
                <img
                  src={plus}
                  alt="plus"
                  style={{
                    transform:
                      expanded === "panel1" ? "rotate(45deg)" : "rotate(0deg)",
                  }}
                ></img>
              }
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography
                sx={{
                  color: "#000",
                  fontSize: 18,
                  fontWeight: 600,
                  fontFamily: '"Inter", sans-serif',
                }}
              >
                How does it work?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  color: "#0004F575E",
                  fontSize: 18,
                  fontWeight: 400,
                  fontFamily: '"Inter", sans-serif',
                  lineHeight: "22px",
                }}
              >
                Basic information about blockchain. Thanks to blockchain technology, every transaction is recorded and irreversibly verified. Povego stores crypto assets securely and transparently on the blockchain. Tokenization is the name given to the opportunity to invest for wider audiences by creating digital representations of assets.
                

              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
            sx={{
              border: expanded === "panel2" && "1px solid #E63B1F",
              borderRadius: "6px",
              marginBottom: "12px",
            }}
          >
            <AccordionSummary
              expandIcon={
                <img
                  src={plus}
                  alt="plus"
                  style={{
                    transform:
                      expanded === "panel2" ? "rotate(45deg)" : "rotate(0deg)",
                  }}
                ></img>
              }
              aria-controls="panel2bh-content"
              id="panel2bh-header"
            >
              <Typography
                sx={{
                  color: "#000",
                  fontSize: 18,
                  fontWeight: 600,
                  fontFamily: '"Inter", sans-serif',
                }}
              >
                Why should we choose Povego?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  color: "#0004F575E",
                  fontSize: 18,
                  fontWeight: 400,
                  fontFamily: '"Inter", sans-serif',
                  lineHeight: "22px",
                }}
              >
                Thanks to our user-friendly interface that appeals to both beginners and professionals, you can trade quickly and easily. By offering a wide range of cryptocurrencies, we provide many investment opportunities from popular tokens to innovative projects. While offering the chance to obtain maximum earnings with our competitive commission rates and regular campaigns, we ensure you save time with our fast transaction and withdrawal processes. We are always by our users' side with Turkish 24/7 customer support and payment methods specific to Türkiye. You are at the right address for a reliable, fast, and user-oriented crypto investment experience.

              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
            sx={{
              border: expanded === "panel3" && "1px solid #E63B1F",
              borderRadius: "6px",
              marginBottom: "12px",
            }}
          >
            <AccordionSummary
              expandIcon={
                <img
                  src={plus}
                  alt="plus"
                  style={{
                    transform:
                      expanded === "panel3" ? "rotate(45deg)" : "rotate(0deg)",
                  }}
                ></img>
              }
              aria-controls="panel3bh-content"
              id="panel3bh-header"
            >
              <Typography
                sx={{
                  color: "#000",
                  fontSize: 18,
                  fontWeight: 600,
                  fontFamily: '"Inter", sans-serif',
                }}
              >
                How do I trade?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  color: "#0004F575E",
                  fontSize: 18,
                  fontWeight: 400,
                  fontFamily: '"Inter", sans-serif',
                  lineHeight: "22px",
                }}
              >
                After becoming a member of Povego, you can easily buy and sell by transferring Turkish Lira from your bank account, and track your total assets and account movements. You can only transfer money to Povego from your own bank account. Transfers made from third-party accounts or accounts opened with a tax identification number are not accepted. If you are going to perform an EFT transaction, you must enter the recipient name as "Povego A.S.". If you are going to make a wire transfer, the recipient name will automatically appear on the screen after entering the IBAN number. After entering the amount you want to send, you can complete your transaction by leaving the transaction description blank. If your bank does not allow you to leave the transaction description blank, you can enter your name and surname information. You can easily track your Turkish Lira deposit transaction from the Account Movements section in the panel. The amount you deposited will be transferred to your account shortly after it reaches the Povego account.

              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Container>
    </React.Fragment>
  );
}

export default FaqSection;
